module.exports = __webpack_public_path__ + "img/path-2.1981ee0f.png";